module.exports = __webpack_public_path__ + "static/teaser-5-3ac21cedaa9a851d022f40e8811ff229.png";